import { render, staticRenderFns } from "./company-associations.vue?vue&type=template&id=453d0e4b&"
import script from "./company-associations.vue?vue&type=script&lang=js&"
export * from "./company-associations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports